import { render, staticRenderFns } from "./CDRQSummary.vue?vue&type=template&id=3dce236d&scoped=true&"
import script from "./CDRQSummary.vue?vue&type=script&lang=ts&"
export * from "./CDRQSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce236d",
  null
  
)

export default component.exports